module.exports = __webpack_public_path__ + "img/playtop_sp@2x_.4d15045c.png";